import React from 'react';

/**
 * Isometric-style badge icons for the 8 achievement badges.
 * Each is an SVG component with `size` and `className` props.
 */

export const BadgeChatIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <path d="M16 18h32a4 4 0 014 4v16a4 4 0 01-4 4H28l-8 8v-8h-4a4 4 0 01-4-4V22a4 4 0 014-4z" fill="currentColor" opacity="0.2"/>
    <path d="M14 16h32a4 4 0 014 4v16a4 4 0 01-4 4H26l-8 8v-8h-4a4 4 0 01-4-4V20a4 4 0 014-4z" fill="currentColor" opacity="0.4"/>
    <path d="M12 14h32a4 4 0 014 4v16a4 4 0 01-4 4H24l-8 8v-8h-4a4 4 0 01-4-4V18a4 4 0 014-4z" fill="currentColor"/>
    <circle cx="24" cy="26" r="2" fill="white"/>
    <circle cx="32" cy="26" r="2" fill="white"/>
    <circle cx="40" cy="26" r="2" fill="white"/>
  </svg>
);

export const BadgeLightbulbIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <path d="M34 12a14 14 0 00-9 24.7V42a3 3 0 003 3h12a3 3 0 003-3v-5.3A14 14 0 0034 12z" fill="currentColor" opacity="0.2" transform="translate(2 2)"/>
    <path d="M32 10a14 14 0 00-9 24.7V40a3 3 0 003 3h12a3 3 0 003-3v-5.3A14 14 0 0032 10z" fill="currentColor"/>
    <rect x="26" y="44" width="12" height="3" rx="1.5" fill="currentColor" opacity="0.7"/>
    <rect x="28" y="49" width="8" height="3" rx="1.5" fill="currentColor" opacity="0.5"/>
    <path d="M32 18v8M28 22h8" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);

export const BadgeFireIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <path d="M34 8c0 8-4 12-4 18s6 12 6 12 10-6 10-16S34 8 34 8z" fill="currentColor" opacity="0.2" transform="translate(2 2)"/>
    <path d="M32 6c0 8-4 12-4 18s6 12 6 12 10-6 10-16S32 6 32 6z" fill="currentColor"/>
    <path d="M28 24c0 4-2 6-2 10s3 6 3 6 5-2 5-8-6-8-6-8z" fill="currentColor" opacity="0.3"/>
    <path d="M20 28c0 8 4 14 4 14s-2-4-2-8 4-8 4-8-6-2-6 2z" fill="currentColor" opacity="0.6"/>
    <ellipse cx="32" cy="44" rx="10" ry="4" fill="currentColor" opacity="0.15"/>
  </svg>
);

export const BadgeFireAltIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <path d="M34 6c0 10-6 14-6 22s8 14 8 14 12-6 12-18S34 6 34 6z" fill="currentColor" opacity="0.2" transform="translate(2 2)"/>
    <path d="M32 4c0 10-6 14-6 22s8 14 8 14 12-6 12-18S32 4 32 4z" fill="currentColor"/>
    <path d="M26 26c0 6-3 8-3 12s4 8 4 8 6-4 6-10-7-10-7-10z" fill="currentColor" opacity="0.3"/>
    <path d="M18 30c0 10 6 16 6 16s-4-4-4-10 6-10 6-10-8-2-8 4z" fill="currentColor" opacity="0.6"/>
    <path d="M32 34l-2 8h4l-2-8z" fill="white" opacity="0.6"/>
    <ellipse cx="32" cy="48" rx="12" ry="4" fill="currentColor" opacity="0.15"/>
  </svg>
);

export const BadgeCompassIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <circle cx="34" cy="34" r="20" fill="currentColor" opacity="0.15"/>
    <circle cx="32" cy="32" r="20" fill="currentColor" opacity="0.3"/>
    <circle cx="32" cy="32" r="18" fill="currentColor"/>
    <circle cx="32" cy="32" r="14" fill="none" stroke="white" strokeWidth="1.5" opacity="0.4"/>
    <polygon points="32,18 36,30 32,34 28,30" fill="white"/>
    <polygon points="32,46 28,34 32,30 36,34" fill="white" opacity="0.5"/>
    <circle cx="32" cy="32" r="3" fill="white"/>
  </svg>
);

export const BadgeMagnifyingGlassIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <circle cx="30" cy="28" r="14" fill="currentColor" opacity="0.2" transform="translate(2 2)"/>
    <circle cx="28" cy="26" r="14" fill="currentColor"/>
    <circle cx="28" cy="26" r="10" fill="none" stroke="white" strokeWidth="2.5"/>
    <line x1="38" y1="36" x2="50" y2="48" stroke="currentColor" strokeWidth="5" strokeLinecap="round"/>
    <line x1="38" y1="36" x2="50" y2="48" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.5" transform="translate(1 1)"/>
    <circle cx="25" cy="23" r="3" fill="white" opacity="0.4"/>
  </svg>
);

export const BadgeCameraIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <rect x="10" y="22" width="44" height="28" rx="4" fill="currentColor" opacity="0.2" transform="translate(2 2)"/>
    <rect x="8" y="20" width="44" height="28" rx="4" fill="currentColor"/>
    <path d="M24 20l2-6h12l2 6" fill="currentColor" opacity="0.7"/>
    <circle cx="30" cy="34" r="9" fill="none" stroke="white" strokeWidth="2.5"/>
    <circle cx="30" cy="34" r="5" fill="white" opacity="0.3"/>
    <circle cx="44" cy="26" r="2" fill="white" opacity="0.5"/>
  </svg>
);

export const BadgeStarIcon = ({ size = 32, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className}>
    <path d="M34 8l6 14h14l-11 9 4 15-13-9-13 9 4-15-11-9h14z" fill="currentColor" opacity="0.2" transform="translate(2 2)"/>
    <path d="M32 6l6 14h14l-11 9 4 15-13-9-13 9 4-15-11-9h14z" fill="currentColor"/>
    <path d="M32 14l3.5 8h8l-6.5 5.2 2.5 8.8L32 30.5 24.5 36l2.5-8.8L20.5 22h8z" fill="white" opacity="0.3"/>
  </svg>
);

const BADGE_ICON_MAP = {
  speech_bubble: BadgeChatIcon,
  lightbulb: BadgeLightbulbIcon,
  fire_3: BadgeFireIcon,
  fire_7: BadgeFireAltIcon,
  compass: BadgeCompassIcon,
  magnifying_glass: BadgeMagnifyingGlassIcon,
  camera: BadgeCameraIcon,
  star: BadgeStarIcon,
};

export default BADGE_ICON_MAP;
